import React from 'react';
import { Box } from 'rebass/styled-components';
import { Input } from '@rebass/forms';
import theme from '../../theme';

const InputDate = ({ name, keyPressHandler, required }) => {
  const buttonId = 'b_' + name;
  return (
    <Box pb={4}>
      <Input
        type="date"
        maxLength="8"
        id={name}
        name={name}
        onKeyDown={e => keyPressHandler(e, buttonId, name)}
        required={required}
        sx={{
          color: `${theme.colors.main}`,
          fontSize: `24px`,
          lineHeight: `1.31`,
          letterSpacing: `0.4px`,
          border: `0`,
          borderBottom: `1px solid RGBA(114,109,225,0.3)`,
          outline: `none`,
          paddingY: `5px`,
          paddingX: `0`,
          '&: focus': {
            borderBottom: `2px solid ${theme.colors.main}`
          },
          ':: placeholder': {
            color: `${theme.colors.main}`,
            opacity: `0.3`
          }
        }}
      />
    </Box>
  );
};

export default InputDate;
